import type { LensState } from '~/pages/LeLens/document/types';

import { reportingLeLensPath } from '~/consts/reportingLeLensApi';

import { request } from '~/services/common';

import { resolveReportingLeLensUrl } from './resolveReportingLeLensUrl';

export async function downloadLensCsv(lensId: string, body: { state: LensState; blocks: Array<string>; tabs?: Array<string> }) {
  const response = (await request(resolveReportingLeLensUrl(`${reportingLeLensPath(lensId)}/csv`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    returnResponse: true,
  })) as Response;
  const name = /filename="([^"]+)"/.exec(response.headers.get('content-disposition') ?? '')?.[1] ?? 'lens.csv';
  const link = document.createElement('a');
  link.href = URL.createObjectURL(await response.blob());
  link.download = name;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}
